export default function Refresh({ style, stroke = '#8FC045', width = '16', height = '16' }) {
  return (
    <svg
      className={style}
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_3154_28359)'>
        <path
          d='M14.6668 8.00065C14.6668 11.6807 11.6802 14.6673 8.00016 14.6673C4.32016 14.6673 2.0735 10.9607 2.0735 10.9607M2.0735 10.9607H5.08683M2.0735 10.9607V14.294M1.3335 8.00065C1.3335 4.32065 4.2935 1.33398 8.00016 1.33398C12.4468 1.33398 14.6668 5.04065 14.6668 5.04065M14.6668 5.04065V1.70732M14.6668 5.04065H11.7068'
          stroke={stroke}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_3154_28359'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
